import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withTranslation } from "react-i18next";
import { withStyles } from "@material-ui/core";
import { ExpandMore, ExpandLess } from "@material-ui/icons";
import moment from "moment";

function SingleApiKey(props) {
  const { classes, t, token, requestRevoke } = props;
  const [expanded, toggleExpand] = useState(false);

  return (
    <div className={classes.container}>
      <div className="top">
        <span>{t("id")}:</span>
        <p className="identifier">{token.jti}</p>
        {token.rat ? (
          <p className="status revoked">{t("revoked")}</p>
        ) : (
          <p className="status active">{t("active")}</p>
        )}
        {expanded ? (
          <ExpandLess onClick={() => toggleExpand(!expanded)} />
        ) : (
          <ExpandMore onClick={() => toggleExpand(!expanded)} />
        )}
      </div>
      {expanded ? (
        <div className="bottom">
          <div className="bottomItem">
            <p className="key">{t("scopes")}:</p>
            <p className="value">{token.scp.map((s) => `${t(s)} `)}</p>
          </div>
          <div className="bottomItem">
            <p className="key">{t("expiry")}:</p>
            <p className="value">
              {moment.unix(token.exp).format("MMMM Do YYYY, h:mm:ss a")}
            </p>
          </div>

          {token.rat ? (
            <div className="bottomItem">
              <p className="key">{t("revokedAt")}:</p>
              <p className="value">
                {moment.unix(token.rat).format("MMMM Do YYYY, h:mm:ss a")}
              </p>
            </div>
          ) : (
            <button onClick={() => requestRevoke(token.jti)}>
              {t("revoke")}
            </button>
          )}
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

// Increase height to 48px Font size: 16px Arrow colour: #BEBDBD Radius border: 2

const styles = (theme) => ({
  container: {
    background: theme.colors.background.lightFore,
    padding: "8px 24px",
    borderRadius: 4,
    marginBottom: 8,
    height: "auto",
    minHeight: 48,
    "& .top": {
      display: "flex",
      alignItems: "center",
      position: "relative",

      "& span": {
        color: theme.colors.text.secondary,
        marginRight: 4,
        fontSize: 16,
      },
      "& .identifier": {
        fontSize: 16,
      },
      "& .status": {
        padding: "4px 8px",
        borderRadius: 4,
        marginLeft: 16,
        border: "1px solid transparent",
        textTransform: "uppercase",
        "&.active": {
          color: theme.colors.buttons.buy,
          borderColor: theme.colors.buttons.buy,
        },
        "&.revoked": {
          color: theme.colors.buttons.sell,
          borderColor: theme.colors.buttons.sell,
        },
      },
      "& svg": {
        position: "absolute",
        cursor: "pointer",
        right: 16,
        top: "50%",
        transition: ".3s",
        transform: "translateY(-50%)",
        color: theme.colors.text.secondary,
        "&:hover": {
          opacity: 0.3,
        },
        [theme.breakpoints.down(550)]: {
          right: 0,
          transform: "translate(100%, -50%)",
        },
      },
    },
    "& .bottom": {
      padding: "8px 0 0",
      "& .bottomItem": {
        display: "flex",
        alignItems: "center",
        marginBottom: 4,
        // fontFamily: "Titillium Web",
        "& .key": {
          color: theme.colors.text.secondary,
          marginRight: 8,
        },
        "& .value": {
          color: theme.colors.text.primary,
        },
      },
      "& button": {
        ...theme.defaults.roundBtn,
        background: theme.colors.buttons.green,
        height: 25,
        fontSize: 14,
        minHeight: "none",
        marginTop: 8,
      },
    },
  },
});

export default withStyles(styles)(
  withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SingleApiKey))
);
